// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-with-multiple-data {
  display: flex;
  flex-direction: column !important;
}

.nowrap-column {
  white-space: nowrap;
}

.break-words-column {
  word-break: break-word;
}

.compact-column {
  max-width: -moz-fit-content;
  max-width: fit-content;
}

.sticky-header {
  position: sticky;
  top: 120px;
}

.no-mb {
  margin-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/view-table/view-table.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,2BAAA;EAAA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,2BAAA;AACF","sourcesContent":[".column-with-multiple-data {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.nowrap-column {\n  white-space: nowrap;\n}\n\n.break-words-column {\n  word-break: break-word;\n}\n\n.compact-column {\n  max-width: fit-content;\n}\n\n.sticky-header {\n  position: sticky;\n  top: 120px;\n}\n\n.no-mb {\n  margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
